import * as React from 'react';
import { cn } from '@/lib/utils';

const Loader = React.forwardRef(({ className, ...props }, ref) => (
  <LoaderContainer>
    <div
      ref={ref}
      data-id="loader"
      className={cn(
        'relative h-3 w-[100px] animate-progress rounded-full border border-solid border-neutral-lighter bg-gradient-to-br from-bright via-primary-lightest to-primary-lightest bg-[length:0%_100%] bg-left bg-no-repeat',
        "after:content-'' after:absolute after:inset-0 after:animate-progress-fade after:rounded-full after:bg-[repeating-linear-gradient(-45deg,rgba(136,148,172,0)_0px,rgba(136,148,172,0)_10px,#8894AC_10px,#8894AC_20px)] after:bg-[length:0%_100%] after:bg-left after:bg-no-repeat after:opacity-0",
        className
      )}
      {...props}
    />
  </LoaderContainer>
));
Loader.displayName = 'Loader';

const LoaderContainer = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-id="loader-container"
    className={cn('flex min-h-[40px] w-full animate-fade-in items-center justify-center bg-transparent', className)}
    {...props}
  />
));
LoaderContainer.displayName = 'LoaderContainer';

const LoaderWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-id="loader-wrapper"
    className={cn('flex flex-col items-center gap-5 text-center', className)}
    {...props}
  />
));
LoaderWrapper.displayName = 'LoaderWrapper';

const LoaderWrapperText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    data-id="loader-wrapper-text"
    className={cn('mb-0 text-base font-bold leading-tight text-neutral-darker', className)}
    {...props}
  />
));
LoaderWrapperText.displayName = 'LoaderWrapperText';

const LoaderSpinner = React.forwardRef(({ text = 'Gerando o relatório', className, ...props }, ref) => (
  <LoaderWrapper>
    {text && <LoaderWrapperText>{text}</LoaderWrapperText>}
    <div
      ref={ref}
      data-id="loader-spinner"
      className={cn('aspect-square w-8 animate-spinner rounded-full [-webkit-mask:radial-gradient(farthest-side,transparent_calc(100%-4px),#000_0)]', className)}
      style={{ background: 'radial-gradient(farthest-side,#8894AC 94%,#0000) top/4px 4px no-repeat, conic-gradient(#0000 30%,#8894AC)' }}
      {...props}
    />
  </LoaderWrapper>
));
LoaderSpinner.displayName = 'LoaderSpinner';

export { Loader, LoaderContainer, LoaderSpinner };
